import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();

  return (
    <div className=" 
    px-2 
    sm:px-4  
    py-2.5
    bg-th-blue-400 
    container 
    mx-auto">
      <h1 className='text-2xl md:text-4xl text-th-white py-4 w-full'>Oops!</h1>
      <p className='text-md text-th-white font-bolt'>Sorry, an unexpected error has occurred.</p>
      <p>
        <i className="text-md text-th-white-900 font-bolt">{error?.statusText || error?.message }</i>
      </p>
    </div>
  );
};

export default ErrorPage;